import PlusIcon from '@/assets/images/icon-plus.svg?react';
import Button from '@/components/button';
import {BUTTON_ICON_POSITION, BUTTON_THEME, BUTTON_VARIANT} from '@/constants/button';
import {DocumentInputField} from '@/engine/types';
import {ICON_TYPES, IconType} from '@/model/types';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import {useDocumentLocale} from '../../hooks/use-document-locale';
import {FieldProps} from '../../meta-field';

export const ButtonField = ({field, handleClick}: FieldProps<DocumentInputField>) => {
  const {_t} = useDocumentLocale();

  return (
    <Button
      disabled={field.disabled}
      theme={BUTTON_THEME.SECONDARY}
      variant={BUTTON_VARIANT.FORM_FIELD}
      icon={<ButtonIcon iconType={field.button?.icon} />}
      iconPosition={BUTTON_ICON_POSITION.RIGHT}
      onClick={handleClick}
      label={_t(field.button?.label)}
      trackingKey={WEB_CLICK_TRACKING_KEY.DOCUMENT_BUTTON_FIELD}
    />
  );
};

const ButtonIcon = ({iconType}: {iconType: IconType | undefined}) => {
  switch (iconType) {
    case ICON_TYPES.ADD:
      return <PlusIcon className="size-5" />;
    default:
      return <></>;
  }
};
